<template>
  <el-select
    :value="value"
    size="mini"
    style="width: 100px"
    :disabled="disabled"
    v-bind="props"
    @change="changeEvent"
  >
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script>
const PropsType = () => {
  return [Number, String, Object];
};
export default {
  props: {
    /**
     * 绑定值
     */
    value: {
      type: new PropsType(),
      default: null,
    },

    /**
     * 选项列表
     */
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },

    /**
     * 是否禁用
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * 选择框属性对象
     */
    props: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    changeEvent(val) {
      this.$emit('change', val);
    },
  },
};
</script>

<style>

</style>
